export const FETCH_PAYMENT = 'fetchPayments';
export const CREATE_PAYMENT = 'createPayments';
export const PSE_STATUS = 'pseStatus';
export const FETCH_BANKS_PSE = 'fetchBanksPse';
export const ACTION_BRAND = 'actionBrand';
